import axios from "axios";
import { AdminMessage } from "../entities/formTemplateDataType";
import { getEnvVar } from "../config/RuntimeConfig";

export const getAdminConfig = async (appName?: string) => {
    if (getEnvVar('MaintenanceMode') === 'true') {
        return { 
            messageContent: 'The system is currently under maintenance. Please try again later.',
            messageType: 'Maintenance',
            messageContentFrench: 'Le système est actuellement en maintenance. Veuillez réessayer plus tard.',
            isActive: true,
            fromTime: '2025-03-03T20:00:00',
            toTime: '2025-03-04T20:00:00',
         };
    }

    const adminUrl = `${getEnvVar('ADMIN_SERVICE_API_URL')}/${appName}`;
    try {
        const response = await axios.get<{data?: AdminMessage; message?: string; status?: string;}>(adminUrl, {
            headers: { 
                'X-API-Key': getEnvVar('ADMIN_SERVICE_API_KEY'),
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': 'X-Requested-With',
            },
        });

        if (response.status !== 200) {
            return undefined;
        }
        return response.data?.data;
    } catch (error) {
        console.error("Error fetching CXP profile:", error.response?.data || error.message);
        return undefined;
    }
}